import { render, staticRenderFns } from "./BlocGroup.vue?vue&type=template&id=0cbb295e&lang=pug&"
import script from "./BlocGroup.vue?vue&type=script&lang=js&"
export * from "./BlocGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbb295e')) {
      api.createRecord('0cbb295e', component.options)
    } else {
      api.reload('0cbb295e', component.options)
    }
    module.hot.accept("./BlocGroup.vue?vue&type=template&id=0cbb295e&lang=pug&", function () {
      api.rerender('0cbb295e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/blocmenu/BlocGroup.vue"
export default component.exports